module.exports = __webpack_public_path__ + "img/setting_5.e21bda37.svg";